import moment from 'moment'

export function toMoment(value) {
  if (Array.isArray(value)) {
    return moment([value[0], value[1] - 1, value[2]])
  }

  return moment(value)
}

export function formatDate(value, format = 'DD-MM-YYYY') {
  return value ? toMoment(value).format(format) : '-'
}